import { DropDownBox } from '@apply/components';
import {
    ExperiencePropertyTwoToFourUnitStructureType,
    ExperiencePropertyTwoToFourUnitStructureTypeOptions,
} from '@apply/constants';
import { useExperienceTwoToFourUnitTypeId, useExperienceUnitCount } from '../../../../fields/ExperienceFields';

export interface TwoToFourUnitStructureProps {
    experienceId: string | undefined;
    width?: string;
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
}

export const TwoToFourUnitStructure: React.FC<TwoToFourUnitStructureProps> = ({
    experienceId,
    required = false,
    readOnly = false,
}) => {
    const label = '2-4 Unit Structure Type ';
    const [twoToFourUnitTypeId, set_twoToFourUnitTypeId] = useExperienceTwoToFourUnitTypeId(experienceId);
    const [, set_unitCount] = useExperienceUnitCount(experienceId);

    const twoToFourUnitOptions = ExperiencePropertyTwoToFourUnitStructureTypeOptions.map((o) => ({
        display: o.name,
        value: o.id,
    }));

    const onPropertyTwoToFourUnitTypeChange = (id: ExperiencePropertyTwoToFourUnitStructureType | undefined) => {
        // Only run if the value actually changed
        if (id === twoToFourUnitTypeId) {
            return;
        }

        switch (id) {
            case ExperiencePropertyTwoToFourUnitStructureType.Two:
                set_unitCount(2);
                break;
            case ExperiencePropertyTwoToFourUnitStructureType.Three:
                set_unitCount(3);
                break;
            case ExperiencePropertyTwoToFourUnitStructureType.Four:
                set_unitCount(4);
                break;
        }

        set_twoToFourUnitTypeId(id);
    };

    return (
        <DropDownBox
            id='experienceProjectType'
            value={twoToFourUnitTypeId}
            onChange={(value) => onPropertyTwoToFourUnitTypeChange(value)}
            required={required}
            dataSource={twoToFourUnitOptions}
            displayExpr='display'
            valueExpr='value'
            label={label}
            readOnly={readOnly}
        />
    );
};
